import cx from 'classnames';
import { FC, MouseEventHandler } from 'react';

import { NAVIGATION_ITEM_COLORS } from '@/shared/constants';
import { GenericNavItem } from '@/types/Navigation';

import styles from '../navigation.module.scss';

interface Props {
  subMenuItemChunks?: GenericNavItem[][];
  onMouseLeave?: MouseEventHandler;
}

const SubNavigation: FC<Props> = ({ subMenuItemChunks, onMouseLeave }) => {
  return (
    <div className={styles.subNavigationContainer} onMouseLeave={onMouseLeave}>
      {subMenuItemChunks
        ?.filter((chunk: GenericNavItem[]) => chunk?.length > 0)
        .map((chunk: GenericNavItem[], index: number) => (
          <ul className={styles.subNavigation} key={index}>
            {chunk &&
              chunk.map(({ id, link, text, bold, color }: GenericNavItem) => (
                <li
                  key={id}
                  className={cx(styles.subNavigationItem, {
                    [styles.subNavigationItemHeader]: !link,
                    [styles.subNavigationItemHover]: link,
                    [styles.subNavigationItemBold]: bold,
                    [styles.subNavigationItemBlack]: color?.name === NAVIGATION_ITEM_COLORS.BLACK,
                    [styles.subNavigationItemFire]: color?.name === NAVIGATION_ITEM_COLORS.FIRE,
                    [styles.subNavigationItemOrca]: color?.name === NAVIGATION_ITEM_COLORS.ORCA,
                  })}
                >
                  <a tabIndex={0} role="button" href={link} className={styles.navToplevelItemLink}>
                    {text}
                  </a>
                </li>
              ))}
          </ul>
        ))}
    </div>
  );
};

export default SubNavigation;
